import { buildURL } from 'react-imgix';

export function tryToBuildImgixUrl(
  url: string,
  imgixParams?: Parameters<typeof buildURL>[1],
  options?: Parameters<typeof buildURL>[2]
) {
  try {
    return buildURL(url, imgixParams, options);
  } catch (e) {
    return url;
  }
}
